module.exports = __webpack_public_path__ + "img/equipment.f4f44d2a.jpg";